/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { createContext, useState, useEffect, useContext } from 'react';
import { IPickerModel } from '@rhybus/api'
import { rhybusRListsHttp } from '../components/api/rhybus-list-http'
import { AuthContext } from '../store/AuthContextProvider';

interface UserContextProviderProps {
  children: React.ReactNode;
}

const UserInitalValue = {
  me: null as any,
  meReady: false,
};

const UserContext = createContext(UserInitalValue);

const UserContextProvider: React.FC<UserContextProviderProps> = ({ children }) => {
    const [me, setMe] = useState<IPickerModel>()
    const [meReady, setMeReady] = useState(false)
    const authContext = useContext(AuthContext)

    useEffect(() => {
        if (authContext?.accessToken) {
            doStart()
        }
    }, [authContext?.accessToken])

    async function doStart() {
        try {
            const meValue: any = await rhybusRListsHttp().me()
            setMe(meValue)
            setMeReady(true)
        } catch (error) {
            console.error('Failed to fetch user info, retrying...', error)
            setTimeout(doStart, 2000)
        }
    }

    return (
        <UserContext.Provider value={{ me, meReady }}>
            {children}
        </UserContext.Provider>
    );
};

export { UserContext, UserContextProvider, UserInitalValue }
